const indexName = `TemplateGroup_${process.env.DEPLOY_ENV}`;

const SORT_ITEMS = {
  bestMatch: {
    key: "bestMatch",
    label: "Best Match",
    text: "Default",
    value: indexName,
  },
  newOld: {
    key: "newOld",
    label: "New - Old",
    text: "Created (Recent to Oldest)",
    value: `${indexName}_created_at_i_descending`,
  },
  oldNew: {
    key: "oldNew",
    label: "Old - New",
    text: "Created (Oldest to Recent)",
    value: `${indexName}_created_at_i_ascending`,
  },
  trending: {
    key: "trending",
    label: "Trending",
    text: "Trending",
    value: `${indexName}_past_week_shares_descending`,
  },
  allTimeFaves: {
    key: "allTimeFaves",
    label: "All time faves",
    text: "Most Popular",
    value: `${indexName}_total_shares_descending`,
  },
};

Object.freeze(SORT_ITEMS);

export { SORT_ITEMS };
